import { Trans, useTranslation } from '@e-kyc/translations';

import { Button, ExclamationIcon, Modal } from '../../../components';

export default function OfflineFallbackModal({ open }: { open: boolean }) {
  const { t } = useTranslation();

  return (
    <Modal open={open}>
      <div className='flex w-full flex-col items-center justify-center gap-4 p-4'>
        <div className='flex flex-col items-center justify-center gap-4'>
          <ExclamationIcon />
          <div className='flex flex-col items-center justify-center gap-2'>
            <h5 className='text-error mt-4 font-semibold'>{t('offline.title')}</h5>
            <div className='text-body-1 text-text-secondary text-center'>
              <Trans i18nKey='offline.description' />
            </div>
          </div>
        </div>
        <Button
          className='w-full'
          onClick={() => {
            window.location.reload();
          }}
        >
          {t('button.retry')}
        </Button>
      </div>
    </Modal>
  );
}
